import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import * as fromApp from '../../../store/app.reducers';
import { getCartUpdated } from '../../../store/app.reducers';
import * as fromCart from '../../../store/cart/cart.reducers';
import { CartGroup, CartSampling } from '../../../model/cart.model';
import { ApplicationConstants } from '../../../constants/application-constants';

import { map, take } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { orderCartItemsFn } from '../../../order-checkout/shared/cart';

import { CartProvider } from '../../../core/cart-provider';
import * as CartActions from '../../../store/cart/cart.actions';

import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalService } from 'ng-zorro-antd/modal';
import { IProduct } from '@app/model/contract/product.contract';
import { ProductComponent } from '@app/product/product.component';

@Component({
    selector: 'app-order-summary',
    templateUrl: './order-summary.component.html',
    styleUrls: ['./order-summary.component.scss'],
    animations: [
        trigger('updatedCart', [
            transition(':enter', style({ backgroundColor: '#33FFFF' })),
            transition('* => true', animate('800ms ease-in-out', keyframes([
                style({ backgroundColor: '#FFFFFF' }),
                style({ backgroundColor: '#D3D3D3' }),
                style({ backgroundColor: '#B6B6B6' }),
                style({ backgroundColor: '#D3D3D3' }),
                style({ backgroundColor: '#FFFFFF' })
            ])
            ))]
        )
    ]
})
export class OrderSummaryComponent implements OnInit, OnDestroy {
    @Input() detailed = false;
    @Output() checkoutPageChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    emptyCartMessage = ApplicationConstants.EMPTY_CART;
    isCartEmpty = true;
    storeSubscription: Subscription;
    emptyCartSubscription: Subscription;
    cartUpdatedState = false;
    cartPriceUpdate = false;
    cart: Observable<fromCart.State>;
    groups$: Observable<CartGroup[]>;
    groups: CartGroup[];
    isE2E = false;
    showClearCartButton: boolean;

    constructor(private store: Store<fromApp.AppState>,
        private router: Router,
        private cartService: CartProvider,
        private notification: NzNotificationService,
        private modalService: NzModalService) {
    }

    ngOnInit() {
        this.isE2E = !!environment['e2e'];
        this.showClearCartButton = !!environment['showClearCartButton'];
        this.cart = this.store.select('cart');
        this.groups$ = this.store.select(fromApp.getCartGroups)
            .pipe(map(orderCartItemsFn));


        this.storeSubscription = this.cart.subscribe(
            (data) => {
                this.cartPriceUpdate = data.cartPriceUpdated;
            }
        );

        this.store.select(getCartUpdated)
            .subscribe((updated) => this.cartUpdatedState = updated);

        this.emptyCartSubscription = this.store.select(fromApp.getIsCartEmpty).subscribe(
            emptyStatus => this.isCartEmpty = emptyStatus);
    }

    createComponentModal(item: IProduct): void {
        const modal = this.modalService.create({
            nzTitle: item.name,
            nzContent: ProductComponent,
            nzData: {
                item
            },
            nzWidth: '980px',
            nzWrapClassName: 'vertical-center-modal',
            nzCancelText: 'Close',
            nzOkText: null
        });
    }

    viewCartOrCheckout() {
        if (this.detailed) {
            this.checkoutPageChange.emit(false);
            this.router.navigate(['/checkout/order-information']);
        } else {
            this.checkoutPageChange.emit(true);
            this.router.navigate(['/checkout']);
        }
    }

    renewCart() {
        this.cartService.createCart().pipe(
            take(1))
            .subscribe(
                (cart) => {
                    const cartId = cart.id;
                    window.localStorage.setItem(environment.cartId, cartId);
                    this.store.dispatch(new CartActions.CreateCart(cart));
                    this.store.dispatch(new CartActions.GetCart(cartId));
                },
                (error) => {
                    this.notification.error('Oops! Something went wrong', 'Sorry, we failed to clear your cart. Please try again');
                }
            );
    }

    ngOnDestroy(): void {
        this.storeSubscription.unsubscribe();
        this.emptyCartSubscription.unsubscribe();
    }

    endAnimation($event) {
        this.cartUpdatedState = false;
        this.cartPriceUpdate = false;
    }

    getCartItemType(resourceType = '') {
        const tokens = resourceType.split('.');
        return tokens[0];
    }

    getCartSampling({ name, id: groupId }) {
        return new CartSampling(groupId, name);
    }
}
